/** The newest projects the home shows; its projects' step reads the same page, and the signed-in app's guard too.
 * Kept apart from the set-up's steps, so the guard loads with the app and the steps with the home. */
export const recentProjects = { limit: 3 };
